import React from "react";
import { useParams } from "react-router-dom";
import TvRoom from "../components/TvRoom";

export default function Demo() {
  const { id } = useParams();
  return <TvRoom creativeId={id} />;
}
